// extracted by mini-css-extract-plugin
export default {"modalLoading":"ModalLoading-modalLoading-UKL"};